module.exports = __webpack_public_path__ + "img/patent.4d7a73cd.png";